import React from 'react';
import CheckBox from '../../check-box';
import Badge from '../../badge';
import { renderAsHtml } from '../../../app-actions';

const BusinessCaseProductView = (props) => {
  const {
    productData: {
      recommendedProductName,
      recommendedProductCode,
      recommendationCode,
      recommendationSelected,
      recommendedProductSummary,
    },
    actions: { updateProductRecommendation },
    authorableContent,
    displayCheckBox,
    reducedView = false,
  } = props;
  const { tooltips } = authorableContent;
  const onClickCheckBox = (checkBoxState) => {
    const data = { cidn: props.cidn, checkBoxState };
    updateProductRecommendation(data);
  };
  const recommendedProductSummaryAsHtml = renderAsHtml(recommendedProductSummary);
  return (
    <li className="list-group-item business-case-product">
      <div className="row">
        {!reducedView
          ? <div className="col-1">
            {displayCheckBox ? <CheckBox
              id={recommendedProductCode}
              checked={recommendationSelected}
              callBackAction={onClickCheckBox}
            /> : null
            }
          </div>
          : null}
        <div className={`col${!reducedView ? '-10' : ''}`}>
          <div className="product-name">
            {recommendedProductName}
            {recommendationCode && <Badge tooltip={tooltips[recommendationCode]} id={`bcb-${recommendedProductCode}`} />}
          </div>
          <div className="product-description">
            <p className="product-summary">{recommendedProductSummaryAsHtml}</p>
          </div>
        </div>
      </div>
    </li>
  );
};

export default BusinessCaseProductView;
